import { render, staticRenderFns } from "./RecentDocumentsItemContainer.vue?vue&type=template&id=52744768"
import script from "./RecentDocumentsItemContainer.vue?vue&type=script&lang=ts"
export * from "./RecentDocumentsItemContainer.vue?vue&type=script&lang=ts"
import style0 from "./RecentDocumentsItemContainer.vue?vue&type=style&index=0&id=52744768&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports